<script lang="ts">
  import { browser } from '$app/environment';
  import { beforeNavigate } from '$app/navigation';
  import { updated } from '$app/stores';
  import Cookies from '$components/blocks/Cookies.svelte';
  import NavigationLoader from '$components/elements/NavigationLoader.svelte';
  import ContinueToEmail from '$components/modals/ContinueToEmail.svelte';
  import Error from '$components/modals/Error.svelte';
  import UpdatesListener from '$components/modals/UpdatesListener.svelte';
  import ModalWrapper from '$components/utils/ModalWrapper.svelte';
  import { scrollEnabled, showCookiesPopup } from '$lib/stores';

  beforeNavigate(({ willUnload, to }) => {
    if ($updated && !willUnload && to?.url) {
      location.href = to.url.href;
    }
  });

  let scrollTop = 0;
  let scrollLeft = 0;

  function disableScroll() {
    if (browser) {
      scrollTop = window.scrollY || window.document.documentElement.scrollTop;
      (scrollLeft = window.scrollX || window.document.documentElement.scrollLeft),
        (window.onscroll = function () {
          window.scrollTo(scrollLeft, scrollTop);
        });
    }
  }

  function enableScroll() {
    if (browser) {
      window.onscroll = null;
    }
  }

  $: if (!$scrollEnabled) {
    disableScroll();
  } else {
    enableScroll();
  }
</script>

<svelte:head>
  <script type="text/javascript">
    (function (c, l, a, r, i, t, y) {
      c[a] =
        c[a] ||
        function () {
          (c[a].q = c[a].q || []).push(arguments);
        };
      t = l.createElement(r);
      t.async = 1;
      t.src = 'https://www.clarity.ms/tag/' + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, 'clarity', 'script', 'n17defclm7');
  </script>
</svelte:head>

<NavigationLoader />
<UpdatesListener />
<Error />
<ContinueToEmail />
<Cookies />
<ModalWrapper showModal={$showCookiesPopup}>
  <slot />
</ModalWrapper>
